export default __webpack_public_path__ + "static/media/bayly.074c2b50.jpeg";